<!-- Page Add Dialog -->
<div class="flex flex-column row-gap-2 w-full h-full">
  <!-- Form -->
  @if (pageForm) {
    <medsurf-design-form-control-form
      [formGroup]="pageForm"
      [class]="'w-full'"
      (onSubmit)="onSubmit()">
      <!-- Title -->
      <medsurf-design-form-control-input-text #titleInputText
        [control]="pageForm.controls.title"
        [autofocus]="true"
        [class]="'w-full'"
      [placeholder]="'global.title_add'"></medsurf-design-form-control-input-text>
    </medsurf-design-form-control-form>
  }
  <p-footer>
    <div class="flex flex-row justify-content-end align-items-center column-gap-2">
      <button medsurf-design-input-button [id]="'cancel'"
        [label]="'global.cancel' | translate"
        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
      (click)="dynamicDialogRef.close({result: false})"></button>
      <button medsurf-design-input-button [disabled]="pageForm.invalid"
        [id]="'action'"
        [label]="dynamicDialogConfig.data.inputLabel | translate"
      (click)="!pageForm.invalid && onSubmit()"></button>
    </div>
  </p-footer>
</div>
